interface Props {
    className?: string;
}

export function CalendarIcon({ className }: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
            <path
                d="M14.4688 2.23438H11.5156V1.10938C11.5156 1.03203 11.4523 0.96875 11.375 0.96875H10.3906C10.3133 0.96875 10.25 1.03203 10.25 1.10938V2.23438H5.75V1.10938C5.75 1.03203 5.68672 0.96875 5.60938 0.96875H4.625C4.54766 0.96875 4.48438 1.03203 4.48438 1.10938V2.23438H1.53125C1.22012 2.23438 0.96875 2.48574 0.96875 2.79688V14.4688C0.96875 14.7799 1.22012 15.0312 1.53125 15.0312H14.4688C14.7799 15.0312 15.0312 14.7799 15.0312 14.4688V2.79688C15.0312 2.48574 14.7799 2.23438 14.4688 2.23438ZM13.7656 13.7656H2.23438V7.08594H13.7656V13.7656ZM2.23438 5.89062V3.5H4.48438V4.34375C4.48438 4.42109 4.54766 4.48438 4.625 4.48438H5.60938C5.68672 4.48438 5.75 4.42109 5.75 4.34375V3.5H10.25V4.34375C10.25 4.42109 10.3133 4.48438 10.3906 4.48438H11.375C11.4523 4.48438 11.5156 4.42109 11.5156 4.34375V3.5H13.7656V5.89062H2.23438Z"
                fill="currentColor"
            />
        </svg>
    );
}
